// extracted by mini-css-extract-plugin
export default {"container":"styles_container__XF5uC","selection":"styles_selection__n7srM"};